// 定义分页相关数据
export const mixinsPagination = {
    template: '#pagination',
    data() {
        return {
            //定义分页相关数据
            pagination: {
                total: 500,
                showQuickJumper: false,
                showSizeChanger: true,
                pageSize: 10,
                current: 1,
                showTotal: () => {
                    let { total, current, pageSize } = this.pagination;
                    return `共 ${total} 条记录 第${current + " / " + Math.ceil(total / pageSize) + "页"
                        }`;
                },
                onChange: (current) => {
                    this.pagination.current = current
                    this.getList();
                },//选择页数
                onShowSizeChange: (_, pageSize) => {
                    this.pagination.pageSize = pageSize
                    this.pagination.current = 1
                    this.getList();
                } //每页多少条
            },
        }
    },
    methods: {
        //获取联系人列表
        async getList(val) {
            let customerId = window.localStorage.getItem("customerId");
            let params = {
                ...val,
                customerId,
                current: this.pagination.current,
                size: this.pagination.pageSize,
            };
            let res = await this.$http.get("/sat-maximization/contactInfo/userQueryContactInfo", { params }
            );
            if (res.code == 200) {
                this.pagination.total = res.data.total;
                this.list = res.data.records;
            }
        },
    }
}

// 关于表单查询与重置
export const mixinsFrom = {
    template: '#From',
    data() {
        return {
            form: this.$form.createForm(this),
        }
    },
    methods: {
        //定义表单重置
        resetFields() {
            this.form.resetFields();
        },
    }
}

//定义过滤器
export const mixinsFilter = {
    template: '#Filter',
    filters: {
        filter_primaryContact(value) {
            if (value) {
                return '是'
            } else {
                return '否'
            }
        },
        filter_sex(value) {
            if (value) {
                return '男'
            } else {
                return '女'
            }
        },
        filter_isReally(value) {
            if (value === true) {
                return '是'
            } else if (value === false) {
                return '否'
            } else {
                return value
            }
        },
        filter_weight(value) {
            if (value.includes('教槽')) {
                return "10kg"
            }
            else if (value.includes('保育前期')) {
                return "10kg"
            }
            else if (value.includes('保育后期')) {
                return "15kg"
            }
            else if (value.includes('生长猪')) {
                return "25-50kg"
            }
            else if (value.includes('育肥猪')) {
                return "50-100kg"
            }
            else if (value.includes('大猪')){
                return "100-140kg"
            }
        }
    }
}

//定义时间长
export const transTimer = {
    template: 'Timer',
    methods: {
        timer(msec) {
            let datetime = new Date(msec);
            let year = datetime.getFullYear();
            let month = datetime.getMonth();
            let date = datetime.getDate();
            let hour = datetime.getHours();
            let minute = datetime.getMinutes();
            let second = datetime.getSeconds();

            let result1 = year +
                '-' +
                ((month + 1) >= 10 ? (month + 1) : '0' + (month + 1)) +
                '-' +
                ((date + 1) < 10 ? '0' + date : date) +
                ' ' +
                ((hour + 1) < 10 ? '0' + hour : hour) +
                ':' +
                ((minute + 1) < 10 ? '0' + minute : minute) +
                ':' +
                ((second + 1) < 10 ? '0' + second : second);

            let result2 = year +
                '-' +
                ((month + 1) >= 10 ? (month + 1) : '0' + (month + 1)) +
                '-' +
                ((date + 1) < 10 ? '0' + date : date);

            let result = {
                hasTime: result1,
                withoutTime: result2
            };
            return result;
        }
    }
}